import { render, staticRenderFns } from "./assignment-table.vue?vue&type=template&id=7be4bb63"
import script from "./assignment-table.vue?vue&type=script&lang=js"
export * from "./assignment-table.vue?vue&type=script&lang=js"
import style0 from "./assignment-table.vue?vue&type=style&index=0&id=7be4bb63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports